module.exports = new __parcel__URL__("crash-bandicoot.5c4ed6c1.jpg").toString();